import { render, staticRenderFns } from "./PopupPromotion.vue?vue&type=template&id=342062dd"
import script from "./PopupPromotion.vue?vue&type=script&lang=js"
export * from "./PopupPromotion.vue?vue&type=script&lang=js"
import style0 from "./PopupPromotion.vue?vue&type=style&index=0&id=342062dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports